/* eslint-disable */
import { StringMap } from 'i18next';
import { onGet, onPost, onPostFormData } from './http.api';
import dayjs, { Dayjs } from 'dayjs';
import { Dates } from '@app/constants/Dates';
import axios from 'axios';
import { PersonPackageSelection } from '@app/interfaces/voucher';
dayjs.locale('vi');

export interface Person {
  FullName?: string;
  Gender?: number;
  DateOfBirth?: Dayjs;
  IdentityNo?: string;
  PhoneNo?: string;
  Email?: string;
  Address?: string;
  Relationship?: string;
  EvidenceFiles?: any[];
  PackageIds?: string[];
  PackageSelections?: PersonPackageSelection[];
  voucherId: string;
}
export interface Voucher {
  ID: number;
  campaignId: string;
  Code: string;
  Active: boolean;
  Active_Date: string;
  registerPhone: string;
  registerBy: string;
  limitUser: number;
  isLocked: boolean;
  RegisterPhone: string;
  RegisterBy: string;
}
export interface PersonResponse {
  Voucher: Voucher;
  Patients: Person[];
}
export const initValues: Person = {
  FullName: '',
  Gender: 1,
  DateOfBirth: undefined,
  Email: '',
  PhoneNo: '',
  Address: '',
  IdentityNo: '',
  voucherId: '',
};
export const GetPersons = async (id: string, language: string): Promise<PersonResponse> => {
  const lstP: Person[] = [];
  const response = await onGet<PersonResponse>(`/PatientInfomation/GetPersons?idVoucher=${id}&lang=${language}`);
  response.Patients.map((p) => {
    const abc = p.DateOfBirth && Dates.convertToFormattedDate(p.DateOfBirth.toString());
    lstP.push({ ...p, DateOfBirth: p.DateOfBirth ? (dayjs(abc, 'DD/MM/YYYY') as Dayjs) : undefined });
  });
  return { ...response, Patients: lstP };
};
export interface ICreatePerson {
  phone: string;
  register: string;
  persons: Person[];
}
export const CreatePersons = async (id: string, params: ICreatePerson): Promise<unknown> =>
  await onPost<unknown>(`/PatientInfomation/CreatePersons?idVoucher=${id}`, params);
// export const CreatePersonsMultipart = async (voucherId: string, fd: FormData) => {
//   const res = await onPost<unknown>(`/Patient/CreatePersonsMultipart?voucherId=${voucherId}`, fd);
// };

type CreatePersonsV2Request = {
  personsJson: string;
  register: string;
  phone: string;
  selectedPackageJson: string;
};

export const CreatePersonsV2 = async (
  id: string,
  params: CreatePersonsV2Request,
): Promise<unknown> =>
  await onPost<unknown>(`/PatientInfomation/CreatePersons?idVoucher=${id}`, params);
